<template>
  <div class="card-event" :class="customClasses" :id="content.guid">
    <div class="card-event__inner">
      <div class="card-event__date">
        <CardEventDate :date="startDate" />
      </div>
      <div class="card-event__content">
        <BaseTitle tag="h3" class="card-event__title">
          <!-- <router-link :to="route">{{ content.title }}</router-link> -->
          <BaseButton
            clear
            :url="content.url"
            :target="'_blank'"
            v-if="content.url">
            {{ content.title }}
          </BaseButton>
          <BaseButton
            clear
            :route="route"
            v-else>
            {{ content.title }}
          </BaseButton>
        </BaseTitle>
        <div class="card-event__infos">
          <ul>
            <li v-if="content.schedule.start.date.length">
              <ElementIconText icon="events" >
                Start: {{ content.schedule.start.date }}
              </ElementIconText>
            </li>
            <li v-if="content.schedule.start.time.length">
              <ElementIconText icon="clock">
                {{ content.schedule.start.time }} - {{ content.schedule.end.time }}
              </ElementIconText>
            </li>
            <li v-if="content.location">
              <ElementIconText icon="pin">
                <div v-html="content.location"></div>
              </ElementIconText>
            </li>
            <li v-if="content.documents.length">
              <ElementIconText icon="scarf-pin" >
                <router-link :to="route">{{ $t('message.common.buttons.relatedDocuments') }}</router-link>
              </ElementIconText>
            </li>
          </ul>
          <div class="card-event__description" v-if="display != 'small'">{{ content.description }}</div>
          <BaseButton
            v-if="display !== 'small' && content.disponibility"
            icon="arrow-right"
            icon-position="right"
            color="primary"
            :route="route">
            {{ $t('message.common.buttons.register') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from '@base/BaseTitle'
import BaseButton from '@base/BaseButton'
import CardEventDate from './CardEventDate'
import ElementIconText from '@elements/ElementIconText'

export default {
  name: 'CardEvent',
  components: {
    CardEventDate,
    BaseTitle,
    BaseButton,
    ElementIconText
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  computed: {
    route () {
      return `/calendar/event/${this.content.guid}`
    },
    startDate () {
      return this.content.schedule.start.date
    },
    customClasses () {
      return [
        'card-event',
        `card-event--${this.content.type.guid}`,
        `card-event--${this.display}`
      ]
    }
  }
}
</script>

<style lang="scss">
.card-event{

  @media print {
    background-color: transparent !important;
    page-break-inside: avoid;
  }
  // Card Document MEDIUM LARGE GROUPS

  &--groups,
  &--medium,
  &--large{
    padding: layout("spacing");
    border-radius: layout("border-radius");
    background-color: colors("foreground");

    @each $key, $value in $event-colors{
      &.card-event--#{$key}{
        @media print {
          border-left: .6rem solid $value;
        }
        @include media("small-medium") {
          border-top: .6rem solid $value;
        }
        @include media("large") {
          border-left: .6rem solid $value;
        }
      }
    }
  }

  // Inner

  &__inner{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  // Title

  &__title{
    margin-bottom: .5rem;

    .button {
      font-weight: inherit;
      font-size: inherit;
    }

    .card-event--small &{
      font-size: 1.6rem;
    }
  }

  // Date

  &__date{
    margin-right: layout("spacing");
  }

  // Description

  &__description{
    margin-bottom: 1rem;
  }

  // Infos

  &__infos{
    @include media("small") {
      display: none;
    }

    ul{
      @include no-type-list;
      margin-bottom: 1rem;
    }

    .card-event--small &{
      font-size: 1.3rem;
    }
    .card-event--medium &,
    .card-event--large &{
      font-size: 1.4rem;
    }

    .card-event--groups &{
      .card-event__description {
        display: none;
      }
    }

    .button{
      @media print {
        display: none !important;
      }
    }

  }

  .icon{
    width: 1.6rem;
  }

}
</style>
